import { Box, Flex } from "components/styles";
import { PropsWithChildren } from "react";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import logo from "assets/gtc-logo.png";

import * as Styled from "./styles";
import { LoginLayoutProps } from "./types";

const LoginLayout: React.FC<PropsWithChildren<LoginLayoutProps>> = ({
  children,
  topContent,
  bottomContent,
  title,
  withLogo,
}) => (
  <Box p="2.5rem" maxWidth="24rem" width="100%" m="0 auto">
    {topContent && (
      <Flex justifyContent="center" mb="1.5rem">
        {topContent}
      </Flex>
    )}
    {withLogo && (
      <Flex justifyContent="center" mb="1.5rem">
        <Flex maxWidth="8.25rem" justifyContent="center">
          <Styled.Logo src={logo} alt="Good time design logo" />
        </Flex>
      </Flex>
    )}
    <Text textAlign="center" fontWeight="bold" mb="0.5rem" color="blueDianne">
      {title}
    </Text>
    <Styled.LoginLayoutBox>{children}</Styled.LoginLayoutBox>
    {bottomContent && (
      <Flex justifyContent="center" mt="1.625rem">
        {bottomContent}
      </Flex>
    )}
  </Box>
);

export default LoginLayout;
